module.exports = __webpack_public_path__ + "MaterialIcons-Regular.570eb83859dc23dd0eec.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/@covalent/core/common/styles/font/MaterialIcons-Regular.woff2
// module id = 2015
// module chunks = 2